/**
 * Пустая функция
 */
export var empty = function empty() {};

/**
 * Пустая функция alice @see empty
 */
export var emptyFunc = function emptyFunc() {};